import { useEffect, useState } from "react";
import Button from "../../../../../Components/Button/Button";
import SvgOptions from "../../../../../Components/Svg/SvgOptions";
import css from "./AddQuestion.module.css";
import Svg from "../../../../../Components/Svg/Svg";
import { Get } from "../../../../../Services/Server";
import Url from "../../../../../Services/Url";

const DropdownOptions = ({ questionId, options, setOptions, readOnly }) => {
	const updateIndex = (index, updates) => {
		const copy = [...options];
		copy[index] = { ...copy[index], ...updates };
		setOptions(copy);
	};

	return (
		<>
			{options.map((opt, index) => (
				<div key={index} className={css.OptionGroup}>
					<input
						type="text"
						value={opt.optionText}
						disabled={readOnly}
						onChange={(e) => updateIndex(index, { optionText: e.target.value })}
						className={css.input}
					/>

					<input
						style={{ textAlign: "center" }}
						type="number"
						value={opt.score}
						disabled={readOnly}
						min={0}
						max={10}
						onChange={(e) => updateIndex(index, { score: +e.target.value })}
						className={css.input}
					/>

					<div className={css.RiskToggle}>
						<input
							type="checkbox"
							id={`risk-${questionId}-${index}`}
							className={`${css.Check} ${css.input}`}
							checked={opt.flaggedHighRisk}
							disabled={readOnly}
							onChange={() =>
								updateIndex(index, { flaggedHighRisk: !opt.flaggedHighRisk })
							}
						/>
						<label
							htmlFor={`risk-${questionId}-${index}`}
							className={css.CheckLabel}
						>
							Flag as High Risk
						</label>
					</div>
					{/* remove button */}
					<button
						type="button"
						onClick={() => {
							if (readOnly) return;
							if (index === 0) return;
							if (options.length <= 1) return;
							setOptions(options.filter((_, i) => i !== index));
						}}
						className={css.button}
					>
						<Svg className={css.CloseIcon}>{SvgOptions.Close}</Svg>
					</button>
				</div>
			))}
		</>
	);
};

const AddQuestionForm = ({
	question,
	setQuestion,
	readOnly,
	questionTypes,
}) => {
	const [types, setTypes] = useState(questionTypes || []);

	//  FETCH QUESTION TYPES IF NOT PROVIDED
	useEffect(() => {
		if (!questionTypes || questionTypes.length === 0) {
			Get(Url.riskTemplate.getQuestionTypes)
				.then((data) => {
					setTypes(data);
				})
				.catch((err) => console.error("Failed to load question types", err));
		} else {
			setTypes(questionTypes);
		}
	}, [questionTypes]);

	//SELECT CORRECT QUESTION TYPE AUTOMATICALLY
	useEffect(() => {
		if (!types || types.length === 0) return;

		const current = question?.questionType;

		if (current && types.includes(current)) {
			// Valid match → use it
			setQuestion((prev) => ({ ...prev, type: current }));
		} else {
			// No match → pick random one
			const random = types[Math.floor(Math.random() * types.length)];
			setQuestion((prev) => ({ ...prev, type: random }));
		}
	}, [types, question?.questionType, setQuestion]);

	const update = (field, value) =>
		setQuestion((prev) => ({ ...prev, [field]: value }));

	const options = Array.isArray(question.options) ? question.options : [];

	return (
		<form className={css.form}>
			<div className={css.InputWrapper}>
				<label htmlFor="type">Question Type</label>

				<select
					value={question.type || ""}
					disabled={readOnly}
					onChange={(e) => update("type", e.target.value)}
					className={css.select}
				>
					{types.map((t) => (
						<option key={t} value={t}>
							{t}
						</option>
					))}
				</select>
			</div>

			<div className={css.InputWrapper}>
				<label htmlFor="question">Question</label>
				<input
					type="text"
					placeholder="Input the question"
					disabled={readOnly}
					value={question.questionText || ""}
					onChange={(e) => update("questionText", e.target.value)}
					className={css.input}
				/>
			</div>

			{question.type === "DROPDOWN" && (
				<div className={css.InputWrapper}>
					<label>Options</label>

					<DropdownOptions
						options={options}
						setOptions={(opts) => update("options", opts)}
						readOnly={readOnly}
						questionId={question.id}
					/>

					{!readOnly && (
						<Button
							type="button"
							className={`${css.AddBtn} ${css.button}`}
							onClick={() =>
								update("options", [
									...options,
									{ optionText: "", score: 0, flaggedHighRisk: false },
								])
							}
							icon={SvgOptions.Add}
						>
							Add new option
						</Button>
					)}
				</div>
			)}
		</form>
	);
};

export default AddQuestionForm;
